define('../common/js/isPhone',[],function() {
    'use strict';

    var isPhone = false;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        isPhone = true;
    }

    return isPhone;
});

